
import { useValue } from 'SharedDir/common/composables/useValue';
import { defineComponent } from 'vue';
import { PropType } from 'vue/dist/vue';
import { VisibleColumnItem } from 'SharedDir/stores/settings.store';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';

export default defineComponent({
  name: 'ConfigurableColumn',
  components: {
    SIcon
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object as PropType<VisibleColumnItem>,
      required: true,
    },
  },
  emits: ['changeShow', 'update:modelValue'],
  setup(props, { emit }) {
    const { innerValue, emitValue } = useValue(props, emit);

    function toggle() {
      innerValue.value = !innerValue.value;
      emitValue();
    }

    return {
      toggle,
      innerValue,
    };
  },
});
